namespace Matrix.Visualizer {
    export interface GraphContextMenuItem {
        Caption?: string;
        Icon?: string;
        Url?: string;
        Type?: GraphContextMenuItemType;
    }
}
